import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(tz);

const IST = "Asia/Kolkata";

export function formatINR(value: string | number | null | undefined) {
  if (value === null || value === undefined || value === "") return "—";
  const n = typeof value === "string" ? Number(value) : value;
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(n);
}

export function formatDateTimeIST(value: string | null | undefined) {
  if (!value) return "—";
  return dayjs.utc(value).tz(IST).format("MMM D, YYYY h:mm A");
}

export function formatRelative(value: string | null | undefined) {
  if (!value) return "—";
  return dayjs.utc(value).tz(IST).fromNow();
}

// Credit utilization health bands: green (healthy) → orange (near limit) →
// red (limit almost reached). Returns a hex usable on an antd Tag/text.
export function creditUtilColor(pct: number) {
  if (pct >= 90) return "#DC2626"; // red
  if (pct >= 70) return "#D97706"; // orange
  return "#059669"; // green
}

export function creditUtilLabel(pct: number) {
  if (pct >= 90) return "Limit almost reached";
  if (pct >= 70) return "Near limit";
  return "Healthy";
}

export function initials(name: string) {
  return name
    .split(" ")
    .map((n) => n[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export function avatarColor(name: string) {
  const palette = ["#FEE2E2", "#FEF3C7", "#D1FAE5", "#DBEAFE", "#E0E7FF", "#FCE7F3"];
  const h = name.split("").reduce((a, c) => a + c.charCodeAt(0), 0);
  return palette[h % palette.length];
}
